import '../style/popper-CrsO3PV3.css'
import { ref as P, reactive as Me, computed as l, watch as O, nextTick as ce, onBeforeUnmount as Re, toRefs as de, onMounted as Ue, defineComponent as Ze, toValue as _e, watchEffect as qe, openBlock as C, createElementBlock as R, mergeProps as T, unref as u, createBlock as K, isRef as je, createCommentVNode as F, normalizeProps as Ke, withDirectives as ne, renderSlot as ae, Teleport as Fe, createVNode as Ge, Transition as Je, withCtx as Qe, createElementVNode as Xe, vShow as Ye } from "vue";
import { useMutationObserver as et, useCurrentElement as tt, onClickOutside as rt } from "@vueuse/core";
import { startsWith as U, isEmpty as ot, debounce as se } from "lodash-es";
import nt from "./directives/ripple.js";
import { UPDATE_MODEL_VALUE as le } from "./constant/events.js";
import at from "./internalComponents/Overlay.js";
import { pxlize as st } from "x-utils";
import { createPopper as lt } from "@popperjs/core/lib/popper-lite.js";
import it from "@popperjs/core/lib/modifiers/preventOverflow.js";
import pt from "@popperjs/core/lib/modifiers/flip.js";
import ut from "@popperjs/core/lib/modifiers/offset";
import ct from "@popperjs/core/lib/modifiers/arrow";
import { shortUUID as dt } from "./utils/uuid.js";
import { lightOrDark as ft } from "./utils/color/lightOrDark.js";
import { setCSSVariables as ie } from "./utils/cssVariable.js";
import { getOverlayIndex as vt } from "./hooks/useOverlay.js";
import { useElementHover as pe } from "./hooks/useElementHover.js";
import { useButton as gt } from "./hooks/useButton.js";
const mt = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => {
    e.elements.popper.style.width = `${e.elements.reference.offsetWidth}px`;
  }
}, yt = {
  name: "minWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = "auto", e.styles.popper.minWidth = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => {
    e.elements.popper.style.minWidth = `${e.elements.reference.offsetWidth}px`, e.elements.popper.style.width = "auto";
  }
};
function ht(e, n) {
  let r = {};
  const t = `${st(n)} solid transparent`;
  return U(e, "top") && (r = {
    borderBottom: t
  }), U(e, "bottom") && (r = {
    borderTop: t
  }), U(e, "left") && (r = {
    borderRight: t
  }), U(e, "right") && (r = {
    borderLeft: t
  }), r;
}
const bt = {
  "bottom-start": "top left",
  "bottom-end": "top right",
  "top-start": "bottom left",
  "top-end": "bottom right"
};
function Ct(e) {
  return bt[e];
}
function Ot(e) {
  const n = {
    sameWidth: mt,
    minWidth: yt
  };
  return e.map((r) => n[r]);
}
function fe(e) {
  switch (e) {
    case "popper":
    case "date-picker":
    case "dropdown":
      return "dialog";
    case "multi-select":
    case "select":
      return "listbox";
    case "menu":
      return "menu";
    default:
      return "false";
  }
}
const ue = (e) => parseInt(e, 10), V = [];
let G = 100;
function Pt({
  arrowPadding: e,
  locked: n,
  offsetDistance: r,
  offsetSkid: a,
  placement: t,
  modifiers: i,
  variant: v
}) {
  const o = dt(), c = `${v}-${o}`, d = P(), f = P(), s = Me({
    isOpen: !1,
    isClosing: !1,
    popperInstance: {},
    actualPlacement: "",
    zIndex: null
  }), b = l(() => ht(s.actualPlacement, r.value)), z = l(() => {
    const g = s.actualPlacement || t.value;
    return Ct(g);
  }), x = (g) => {
    s.popperInstance?.setOptions && s.popperInstance.setOptions((D) => ({
      ...D,
      modifiers: [
        ...D.modifiers,
        ...i.value,
        {
          name: "eventListeners",
          enabled: g,
          options: {
            scroll: !0,
            // true
            resize: !0
          }
        }
      ]
    }));
  }, A = () => {
    V.push(c), V.length >= 2 && ++G, s.zIndex = G;
  }, I = () => {
    V.splice(V.indexOf(c), 1), s.isOpen || (s.zIndex = null), s.isClosing = !1, V.length === 0 && (G = 100);
  }, h = () => {
    s.isOpen && (s.isOpen = !1);
  }, W = () => {
    s.isOpen || (s.isOpen = !0);
  }, y = () => !!d.value?.querySelector('div[data-popper-open="true"]');
  O([() => s.isOpen, t], async ([g]) => {
    g ? (L.value = !0, d.value && (await M(), x(!0), A())) : (s.isClosing = !0, d.value && x(!1));
  });
  const L = P(!1), Z = () => {
    L.value = !1, I();
  }, k = {
    name: "topLogger",
    enabled: !0,
    phase: "afterMain",
    fn(g) {
      s.actualPlacement = g.state.placement;
    }
  };
  function N() {
    s.popperInstance.state.elements.popper && s.popperInstance.update();
  }
  const M = async () => {
    s.popperInstance = lt(f.value, d.value, {
      placement: t.value,
      modifiers: [
        k,
        ...i.value,
        it,
        {
          name: "preventOverflow",
          options: {
            altBoundary: !0
            // false by default
          }
        },
        pt,
        {
          name: "flip",
          enabled: !n.value
        },
        ct,
        {
          name: "arrow",
          options: {
            padding: ue(e.value)
          }
        },
        ut,
        {
          name: "offset",
          options: {
            offset: [ue(a.value), 0]
          }
        }
      ]
    }), await ce(), N();
  };
  return et(f, (g) => {
    s.isOpen && g.some((w) => w.attributeName === "style") && N();
  }, {
    attributes: !0,
    subtree: !0
  }), Re(() => {
    const g = s.popperInstance?.destroy;
    g && g(), I();
  }), {
    ...de(s),
    popperId: c,
    shortId: o,
    popperNode: d,
    triggerNode: f,
    tranformOrigin: z,
    interactiveStyle: b,
    modifiedIsOpen: L,
    open: W,
    close: h,
    isChildPopperPresent: y,
    handleTransitionAfterLeave: Z
  };
}
function xt(e) {
  const { manualMode: n, triggerByHover: r } = e;
  if (n.value || !r.value)
    return {
      isHovered: l(() => !1)
    };
  const {
    triggerNode: a,
    popperNode: t,
    fn: i
  } = e, v = { delayLeave: 20 }, o = pe(a, v), c = pe(t, v), d = l(() => o.value || c.value), f = l(() => !o.value && !c.value ? 0 : o.value ? 1 : 2);
  return O(f, (s) => {
    s === 1 ? (a.value?.focus(), i(!0)) : s === 0 && i(!1);
  }), {
    isHovered: d
  };
}
function It(e) {
  const n = tt(), { overlay: r, zIndex: a } = e, t = P(0), i = l(() => typeof r == "object" ? r : {}), v = (f) => {
    t.value = f;
  }, o = P(!1), c = l(() => t.value ? t.value : o.value ? vt() : a.value || "auto"), d = l(() => ({
    zIndex: c.value
  }));
  return Ue(() => {
    setTimeout(() => {
      const f = n.value?.parentElement?.closest('[data-overlay="true"]');
      o.value = f !== null;
    });
  }), {
    overlayZIndex: c,
    overlayOptions: i,
    zIndexStyle: d,
    hasParentOverlay: o,
    handleOverlayZIndex: v
  };
}
function kt(e) {
  const { variant: n, theme: r, disabled: a, colorVariant: t } = e, i = l(() => {
    const o = [`e-${n}`];
    return r && o.push(`e-${n}--${r}`), a?.value && o.push(`e-${n}--disabled`), o;
  }), v = l(() => {
    const o = ["e-popper-node"];
    return t && o.push(`e-popper-node--${t}`), n !== "popper" && o.push(`e-${n}-node`), o;
  });
  return {
    popperContainerClass: i,
    popperNodeClass: v
  };
}
function wt(e) {
  return e === "light" ? "#333" : "#fff";
}
function Bt(e, n, r) {
  if (n) {
    const a = ft(n);
    ie(e, {
      "--popper-theme-background": n,
      "--popper-theme-background-hover": n,
      "--popper-theme-text-color": wt(a)
    });
  }
  if (!ot(r)) {
    const { backgroundColor: a = null, backgroundColorHover: t, textColor: i = null } = r;
    ie(e, {
      "--popper-theme-background": a,
      "--popper-theme-background-hover": t || a,
      "--popper-theme-text-color": i
    });
  }
}
function St({
  popperNode: e,
  isOpen: n,
  autoClose: r,
  offsetDistance: a,
  backgroundColor: t,
  themeStyle: i
}) {
  const v = P(!1), o = l(() => {
    if (r.value) {
      const c = a.value;
      if (Array.isArray(c)) {
        const [d, f] = c;
        return d === 0 ? { borderTop: `${f}px solid transparent`, borderBottom: `${f}px solid transparent` } : { borderLeft: `${d}px solid transparent`, borderRight: `${d}px solid transparent` };
      }
      return { border: `${c}px solid transparent` };
    }
    return {};
  });
  return O(n, (c) => {
    if (c && !v.value) {
      const d = e.value;
      d && Bt(d, t, i), v.value = !0;
    }
  }), {
    interactiveStyle: o
  };
}
function $t(e) {
  const { isOpen: n, overlay: r, hasParentOverlay: a } = e;
  return l(() => {
    const i = {};
    return n.value && (i["data-popper-open"] = "true"), (r || a.value) && (i["data-overlay"] = "true"), i;
  });
}
function Tt(e) {
  const { shortId: n, variant: r, colorVariant: a, isOpen: t, triggerNode: i, triggerButtonProps: v, triggerStyle: o, togglePopper: c, closePopper: d, renderTrigger: f } = e, { buttonClassList: s, buttonStyle: b } = gt({ props: v }), z = l(() => {
    const y = [`e-${r}-trigger`, ...s.value];
    return a && y.push(`e-popper-trigger--${a}`), y;
  }), x = l(() => ({
    ...b.value,
    ...o?.value
  })), A = l(() => ({
    "aria-haspopup": fe(r),
    "aria-expanded": t.value,
    "aria-controls": `${r}-content-${n}`,
    "aria-label": `${r}-trigger`
  })), I = {
    onClick: c,
    onKeydown: (y) => {
      y.key === "Escape" && d(), y.key === "Space" && c(y), y.stopPropagation(), y.preventDefault();
    }
  }, h = l(() => ({
    ...A.value,
    ...I,
    "data-trigger-id": `trigger-${n}`
  }));
  return {
    triggerButtonClass: z,
    triggerButtonStyle: x,
    triggerAttrs: h,
    TriggerComponent: f ? () => f?.(i, h.value) : null
  };
}
function zt(e) {
  const { shortId: n, variant: r, theme: a, size: t } = e, i = l(() => ({
    id: `${r}-content-${n}`,
    role: fe(r),
    tabindex: "-1"
  })), v = l(() => {
    const o = [`e-${r}-content`];
    return t && t.value && o.push(`e-${r}-content--${t.value}`), a && o.push(`e-theme--${a}`), o;
  });
  return {
    contentA11y: i,
    contentClass: v
  };
}
const At = {
  key: 0,
  class: "e-popper-arrow",
  "data-popper-arrow": ""
}, Qt = /* @__PURE__ */ Ze({
  name: "e-popper",
  __name: "popper",
  props: {
    modelValue: { type: Boolean },
    placement: { default: "bottom" },
    variant: { default: "popper" },
    disableClickAway: { type: Boolean, default: !1 },
    clickAwayCapture: { type: Boolean, default: !0 },
    offsetSkid: { default: 0 },
    offsetDistance: { default: 12 },
    size: {},
    renderTrigger: {},
    triggerByHover: { type: Boolean, default: !0 },
    triggerStyle: {},
    triggerButtonProps: {},
    triggerRipple: { type: [Boolean, Object], default: !1 },
    triggerStopPropagation: { type: Boolean, default: !0 },
    contentStyle: {},
    toggleByClick: { type: Boolean, default: !0 },
    show: { type: [Boolean, null], default: null },
    showContent: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    overlay: { type: [Boolean, Object] },
    lazy: { type: Boolean, default: !0 },
    openDelay: { default: 0 },
    closeDelay: { default: 0 },
    arrow: { type: Boolean },
    arrowPadding: { default: "0" },
    autoClose: { type: Boolean, default: !0 },
    locked: { type: Boolean },
    transition: { default: "fade" },
    theme: {},
    themeStyle: { default: () => ({}) },
    backgroundColor: { default: "" },
    teleported: { type: Boolean, default: !0 },
    triggerAttributes: {},
    modifiers: { default: () => [] },
    colorVariant: {}
  },
  emits: ["open", "close", "toggle", "z-index", le],
  setup(e, { expose: n, emit: r }) {
    const a = r, t = e, {
      arrowPadding: i,
      disableClickAway: v,
      disabled: o,
      autoClose: c,
      locked: d,
      offsetDistance: f,
      offsetSkid: s,
      triggerByHover: b,
      toggleByClick: z,
      openDelay: x,
      closeDelay: A,
      placement: I,
      show: h,
      size: W,
      triggerStyle: y,
      contentStyle: L,
      triggerButtonProps: Z
    } = de(t), { variant: k, colorVariant: N, theme: M, backgroundColor: g, themeStyle: D, overlay: w } = t, ve = l(() => _e(t.transition)), ge = l(() => Ot(t.modifiers)), {
      shortId: _,
      popperNode: B,
      triggerNode: q,
      isOpen: m,
      isClosing: me,
      zIndex: ye,
      modifiedIsOpen: he,
      interactiveStyle: be,
      open: Ce,
      close: j,
      isChildPopperPresent: Oe,
      handleTransitionAfterLeave: Pe
    } = Pt({
      arrowPadding: i,
      locked: d,
      offsetSkid: s,
      placement: I,
      modifiers: ge,
      offsetDistance: f,
      variant: k
    }), { popperContainerClass: xe, popperNodeClass: Ie } = kt({ variant: k, colorVariant: N, theme: M, disabled: o });
    St({
      popperNode: B,
      isOpen: m,
      autoClose: c,
      offsetDistance: f,
      backgroundColor: g,
      themeStyle: D
    });
    const { overlayOptions: ke, overlayZIndex: we, zIndexStyle: J, hasParentOverlay: Q, handleOverlayZIndex: Be } = It({
      overlay: w,
      zIndex: ye
    }), X = $t({ isOpen: m, overlay: w, hasParentOverlay: Q }), E = P(!t.lazy), S = l(() => h.value !== null), Se = l(() => m.value && !o.value && t.showContent !== !1), Y = l(() => !v.value && !S.value), ee = se(() => {
      o.value || b.value && !$e.value && !S.value || Ce();
    }, +x.value), te = se(() => {
      Oe() || j();
    }, +A.value), re = async () => {
      o.value || S.value || (E.value = !0, ee());
    }, $ = async () => {
      S.value || te();
    }, { isHovered: $e } = xt({
      triggerNode: q,
      popperNode: B,
      triggerByHover: b,
      manualMode: S,
      fn: (p) => {
        if (p) {
          if (me.value)
            return;
          re();
        } else
          $();
      }
    }), Te = (p) => {
      t.triggerStopPropagation && p.stopPropagation(), !(b.value && !z.value) && (m.value ? $() : re());
    };
    O(() => t.modelValue, (p) => {
      p && !E.value && (E.value = !0), ce(() => {
        m.value = !!p;
      });
    }), O(o, (p) => {
      m.value && p && j();
    }), O(m, (p) => {
      a(m ? "open" : "close"), a(le, p), a("toggle", p);
    }), qe(() => {
      S.value && (E.value = !!h.value, h.value ? ee() : te());
    }), O(we, (p) => {
      a("z-index", p);
    });
    const ze = () => {
      m.value && Y.value && $();
    }, Ae = l(() => w && m.value ? J.value : {}), Le = l(() => ({
      ...J.value,
      ...be.value
    })), { triggerButtonClass: Ne, triggerButtonStyle: De, triggerAttrs: oe, TriggerComponent: Ee } = Tt({
      shortId: _,
      variant: k,
      colorVariant: N,
      isOpen: m,
      triggerNode: q,
      triggerButtonProps: Z,
      triggerStyle: y,
      togglePopper: Te,
      closePopper: $,
      renderTrigger: t.renderTrigger
    }), { contentA11y: He, contentClass: Ve } = zt({ shortId: _, variant: k, theme: M, size: W });
    return rt(B, (p) => {
      if (m.value && Y.value) {
        const H = p.target;
        if (H.closest(`div[data-trigger-id="trigger-${_}"]`) || H.closest(".e-popper-node") && B.value.querySelector("div[data-popper-open]"))
          return;
        $();
      }
    }, { capture: t.clickAwayCapture }), n({
      popperNode: B,
      closePopper: $
    }), (p, H) => (C(), R("div", T({ class: u(xe) }, u(X), { style: Ae.value }), [
      u(w) ? (C(), K(at, T({
        key: 0,
        open: u(m),
        "onUpdate:open": H[0] || (H[0] = (We) => je(m) ? m.value = We : null)
      }, u(ke), {
        "overlay-click": ze,
        variant: "popper",
        "nested-popper": u(Q),
        onZIndex: u(Be)
      }), null, 16, ["open", "nested-popper", "onZIndex"])) : F("", !0),
      p.renderTrigger ? (C(), K(u(Ee), Ke(T({ key: 1 }, u(oe))), null, 16)) : ne((C(), R("div", T({
        key: 2,
        ref_key: "triggerNode",
        ref: q,
        role: "button",
        class: u(Ne),
        style: u(De)
      }, u(oe)), [
        ae(p.$slots, "default")
      ], 16)), [
        [u(nt), p.triggerRipple]
      ]),
      (C(), K(Fe, {
        to: "body",
        disabled: !p.teleported
      }, [
        E.value ? (C(), R("div", T({
          key: 0,
          ref_key: "popperNode",
          ref: B,
          class: u(Ie),
          style: Le.value
        }, u(X)), [
          Ge(Je, {
            name: ve.value,
            onAfterLeave: u(Pe)
          }, {
            default: Qe(() => [
              ne(Xe("div", T({
                class: u(Ve),
                style: u(L)
              }, u(He)), [
                ae(p.$slots, "content", {
                  close: u(j),
                  isOpen: u(he)
                }),
                p.arrow ? (C(), R("div", At)) : F("", !0)
              ], 16), [
                [Ye, Se.value]
              ])
            ]),
            _: 3
          }, 8, ["name", "onAfterLeave"])
        ], 16)) : F("", !0)
      ], 8, ["disabled"]))
    ], 16));
  }
});
export {
  Qt as default
};
//# sourceMappingURL=popper.js.map
